export default "__VITE_ASSET__DpmncgnQ__"